module.exports = __webpack_public_path__ + "static/assets/0130b626059c966bb76a43b50979f8f2.png";